import { BsCloudDownload, BsCloudUploadFill } from "react-icons/bs";
import nodeinstance from "../../../../nodeInstance";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { CiEdit } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router-dom";
import Employeeseclist from "./Editemployeelist";
import SummaryInvoice from "./summaryInvoice";
import { FaArrowCircleDown } from "react-icons/fa";
import DownloadPopUp_OnArrival from "./downloadPDFOnarrival_PopUp";
import Summary_report from "./summaryReport_Template";

export default function SummaryList({
  quotationType,
  quotationId,
  setInvoiceNumber,
  setOnArrivalInvoice,
  summaryUpdate,
  setSelectedInvoice,
  selectedInvoice,
}) {
  console.log(
    "Data to be printed here in console......",
    quotationId,
    quotationType
  );
  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];
  const dispatch = useDispatch();

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const [summaryTrigger, setSummaryTrigger] = useState(false);
  const dummyData = [
    {
      id: 1,
      name: "YTC",
    },
    {
      id: 2,
      name: "YTC",
    },
    {
      id: 3,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
  ];

  const [summary, setSummary] = useState();

  const token = localStorage.getItem("nodeToken");
  const summaryData = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/getInvoiceSummary/${quotationId?.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSummary(response?.data?.data);
      }
    } catch (error) {
      console.log("error......", error);
      dispatch(
        setAppError({
          msg: "failed to fetch the data...",
        })
      );
    }
  };
  useEffect(() => {
    summaryData();
  }, [quotationId, summaryUpdate, summaryTrigger]);
  console.log("summary........summary", summary);
  const navigate = useNavigate();

  const location = useLocation();
  console.log("location........", location.pathname.split("/")[3]);
  const handleEditEmployee = (invoice) => {
    navigate(
      "/dashboard/visa-cost-&-sec-deposit/summary-OnArrival-editEmployee"
    );
    setInvoiceNumber(invoice);
    setOnArrivalInvoice(invoice);
  };

  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
    routeName: "",
  });

  const [popUpOpen, setPopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState();
  const handleUploadClick = (data) => {
    setPopUpOpen(true);
    setPopUpData(data);
  };

  const handleCheckboxChange = (event, id, index) => {
    const isChecked = event.target.checked;
    setSelectedInvoice((prevState) => {
      if (isChecked) {
        // If the checkbox is checked, select the ID
        return [id];
      } else {
        // If the checkbox is unchecked, deselect the ID
        return [];
      }
    });
  };

  const [downloadPDF, SetDownloadPDF] = useState(false);
  const [downloadPDFdata, setDownloadPDFData] = useState();

  const handleDownlaodClick = (value) => {
    SetDownloadPDF(true);
    setDownloadPDFData(value);
  };

  const [clientDetails, setClientDetails] = useState();

  const getClientDetails = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/getClientDetails/${summary[0]?.contract_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setClientDetails(response?.data?.data);
      }
    } catch (error) {
      console.log("error to be displayed here...", error);
      dispatch(
        setAppError({
          msg: "Error while getting client details.",
        })
      );
    }
  };

  useEffect(() => {
    console.log("summary to be seen here.....", summary);
    if (summary?.length > 0) {
      getClientDetails();
      return;
    }
  }, [summary]);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const formattedDate = `${day}-${monthNames[monthIndex]}-${year}`;
    return formattedDate;
  }
  return (
    <>
      <div className="!uppercase">
        <div className="flex justify-between items-center">
          <p className="ml-10">INVOICE SUMMARY</p>
          <div className="flex gap-2 items-center">
            <button
              className="p-2 px-4 rounded-md bg-black text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => {
                Summary_report("Summary_Report", summary);
              }}
            >
              <p>Download Report</p>
            </button>
          </div>
        </div>
        <div
          className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-2"
          style={summary?.length > 3 ? { height: "170px" } : {}}
        >
          <div className="flex">
            {row.map((section, sectionIndex) => (
              <div className="flex flex-col relative" key={sectionIndex}>
                {sectionIndex == 0 && (
                  <>
                    <div className={`flex w-full gap-1 `}>
                      <>
                        {/* <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties2.colWidth} ${tableProperties2.itemHeight}`}
                        >
                          Invoice
                        </h3> */}

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          SL. NO.
                        </h3>

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          MONTHS
                        </h3>

                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          QUANTITY
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          REQUEST/INVOICE.NO
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          INVOICE_TYPE
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          INVOICE AMOUNT
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          INVOICE SENT DATE
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          AMOUNT RECEIVED
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          CREDIT NOTE
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          BALANCE AMOUNT
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          AMOUNT RECEIVED SPLIT
                        </h3>
                        <h3
                          className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                        >
                          Upload Invoice
                        </h3>
                      </>
                    </div>
                  </>
                )}
                <div className="mb-2">
                  {summary?.map((data, index) => (
                    <div
                      className="flex w-full gap-1 relative mb-2 mt-2"
                      key={index}
                    >
                      {/* <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties2.colWidth} ${tableProperties2.colHeight}`}
                      >
                        <input
                          type="checkbox"
                          key={data.id}
                          onChange={(event) => {
                            handleCheckboxChange(event, data, index);
                          }}
                          checked={selectedInvoice?.some(
                            (item) => item.id === data.id
                          )}
                          className="mr-2"
                        />
                      </p> */}
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {index + 1}
                      </p>

                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.months}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.quantity}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.invoice_no}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.invoice_type}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.invoice_amount}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {/* {data.invoices_sent_date} */}
                        {data.invoice_sent_date
                          ? formatDate(data.invoice_sent_date)
                          : "-----"}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.amount_received}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.credit_note}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {parseInt(
                          data.invoice_amount ? data.invoice_amount : 0
                        ) -
                          (parseInt(
                            data.amount_received ? data.amount_received : 0
                          ) +
                            parseInt(
                              data?.credit_note === null ? 0 : data?.credit_note
                            ))}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        {data.quantity === 0
                          ? "CANCELLED"
                          : data.amount_received_split
                            ? data.amount_received_split
                            : "-------"}
                      </p>
                      <p
                        className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                      >
                        <div>
                          <button
                            className="rounded-md bg-white p-1.5 text-sm text-black border border-gray-400 mr-3 ml-4"
                            style={{
                              cursor: "pointer",
                              fontSize: "1rem",
                            }}
                            disabled={
                              data.amount_received_split === "CANCELLED" ||
                              data.quantity === 0
                            }
                            onClick={() => {
                              handleDownlaodClick(data);
                            }}
                          >
                            <FaArrowCircleDown size={"1rem"} />
                          </button>
                          <button
                            className="rounded-md bg-white p-1.5 text-sm text-black border border-gray-400 mr-3 ml-4"
                            style={{
                              cursor: "pointer",
                              fontSize: "1.2rem",
                            }}
                            disabled={
                              data.amount_received_split === "CANCELLED" ||
                              data.quantity === 0
                            }
                            onClick={() => {
                              handleUploadClick(data);
                            }}
                          >
                            <BsCloudUploadFill size={"1rem"} />
                          </button>
                          <button
                            className="rounded-md bg-white p-1.5 text-sm text-black border border-gray-400 mr-3 ml-4"
                            style={{
                              cursor: "pointer",
                              fontSize: "1.2rem",
                            }}
                            onClick={() => {
                              handleEditEmployee(data);
                            }}
                            disabled={
                              data.amount_received_split === "CANCELLED" ||
                              data.quantity === 0
                            }
                          >
                            <CiEdit size={"1rem"} />
                          </button>
                        </div>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        {popUpOpen ? (
          <SummaryInvoice
            popUpOpen={popUpOpen}
            setPopUpOpen={setPopUpOpen}
            popUpData={popUpData}
            setSummaryTrigger={setSummaryTrigger}
            summaryTrigger={summaryTrigger}
          />
        ) : (
          ""
        )}
        {downloadPDF ? (
          <DownloadPopUp_OnArrival
            downloadPDF={downloadPDF}
            SetDownloadPDF={SetDownloadPDF}
            downloadPDFdata={downloadPDFdata}
            summaryProp={quotationId}
            clientDetails={clientDetails}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
